import { showAppAlert } from '../utils/alertService';
import React, { useEffect, useState } from 'react';
import LoaderOverlay from './LoaderOverlay';
import '../styles/formStyles.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function EditPromotionModal({ promotion, visible, onClose, onUpdate }) {
  const [formData, setFormData] = useState({
    nome: '',
    descricao: '',
    data_inicio: '',
    data_termino: '',
    pontos: '',
    status: 1, // Default to active
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (promotion) {
      setFormData({
        nome: promotion.nome || '',
        descricao: promotion.descricao || '',
        data_inicio: promotion.data_inicio || '',
        data_termino: promotion.data_termino || '',
        pontos: promotion.pontos || '',
        status: promotion.status !== undefined ? promotion.status : 1,
      });
    }
  }, [promotion]);

  if (!visible) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const startDate = new Date(formData.data_inicio + 'T00:00:00');
    const endDate = new Date(formData.data_termino + 'T00:00:00');

    // A validação de data de início é feita pelo minDate do DatePicker, mas mantemos aqui por segurança.
    if (startDate < today) {
      showAppAlert('warning', 'A data de início não pode ser anterior à data de hoje.');
      setLoading(false);
      return;
    }

    if (endDate < startDate) {
      showAppAlert('warning', 'A data de término não pode ser anterior à data de início.');
      setLoading(false);
      return;
    }

    const updatedPromotion = {
      nome: formData.nome,
      descricao: formData.descricao,
      pontos: formData.pontos,
      data_inicio: formData.data_inicio,
      data_termino: formData.data_termino,
      status: Number(formData.status),
    };
    const token = localStorage.getItem('token');

    try {
      const response = await fetch(`${API_URL}/promotions/${promotion.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedPromotion),
      });

      if (response.status === 200) {
        showAppAlert('success', 'Promoção atualizada com sucesso!');
        setTimeout(() => {
          onUpdate(); // Notifica o componente pai para recarregar a lista
          onClose();
        }, 1500); // Aguarda 1.5 segundos para o usuário ver a mensagem
      } else {
        const errorData = await response.json();
        showAppAlert('error', `Erro ao atualizar promoção: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Erro ao atualizar promoção:', error);
      showAppAlert('error', `Erro ao atualizar promoção: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <LoaderOverlay isLoading={loading} message="Salvando promoção..." />
      <div className="modal-content">
        <h3>Editar Promoção</h3>
        <form onSubmit={handleSubmit}>
          <div className="label-style">
            <label>Nome:</label>
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              className="input-style"
              required
            />
          </div>
          <div className="label-style">
            <label>Descrição:</label>
            <textarea
              name="descricao"
              value={formData.descricao}
              onChange={handleChange}
              className="input-style"
              required
            />
          </div>
          <div className="form-row">
            <div className="label-style flex-1">
              <label>Data de Início:</label>
              <DatePicker
                selected={formData.data_inicio ? new Date(formData.data_inicio + 'T00:00:00') : null}
                onChange={(date) => handleChange({ target: { name: 'data_inicio', value: date.toISOString().split('T')[0] } })}
                className="input-style"
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/aaaa"
                showYearDropdown
                scrollableYearDropdown
                minDate={new Date()}
                required
              />
            </div>
            <div className="label-style flex-1">
              <label>Data de Término:</label>
              <DatePicker
                selected={formData.data_termino ? new Date(formData.data_termino + 'T00:00:00') : null}
                onChange={(date) => handleChange({ target: { name: 'data_termino', value: date.toISOString().split('T')[0] } })}
                className="input-style"
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/aaaa"
                showYearDropdown
                scrollableYearDropdown
                minDate={formData.data_inicio ? new Date(formData.data_inicio + 'T00:00:00') : new Date()}
                required
              />
            </div>
          </div>
          <div className="label-style">
            <label>Pontos:</label>
            <input
              type="number"
              name="pontos"
              value={formData.pontos}
              onChange={handleChange}
              className="input-style"
              required
            />
          </div>
          <div className="label-style">
            <label>Status:</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className="input-style"
              required
            >
              <option value={1}>Ativo</option>
              <option value={0}>Inativo</option>
            </select>
          </div>
          <div className="button-container">
            <button type="submit" className="button-style" disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
            <button type="button" onClick={onClose} className="button-style cancel" disabled={loading}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditPromotionModal;
